import {makeStyles} from '@material-ui/core/styles';
import {Theme} from './Theme';

export class Styles {
    static readonly loading:any = makeStyles( {
        paper: {
            position:"absolute",
            top:"0",
            left:"0",
            width:"100%",
            height:"100%",
            backgroundColor:"white",
            opacity:0.7,
            boxSizing:"border-box",
        },
        spinner: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
        },
    });
    static readonly base:any = makeStyles( {
        root: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"4em",
            overflow:"hidden",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "0",
                paddingLeft: "0",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        mainRoot: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"2.5em",
            overflow:"hidden",
        },
        modalRoot: {
            height:"100%",
            boxSizing:"border-box",
            overflowX:"hidden",
            overflowY:"auto",
            paddingTop: "3em",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        modalHead: {
            position:"fixed",
            top:"0",
            left:"0",
            width:"100%",
            paddingTop:"0.3em",
            paddingLeft:"0",
            backgroundColor:Theme.palette.primary.main,
            zIndex:999,
        },
        dialogRoot: {
            boxSizing:"border-box",
            padding: "1em",
        },
        modal: {
            position:"absolute",
            width:"100%",
            height:"100%",
            maxWidth:"460px",
            maxHeight:"620px",
            backgroundColor:"#FFFFFF",
            boxSizing:"border-box",
        },
        alert: {
            position:"absolute",
            width:"100%",
            //height:"100%",
            maxWidth:"240px",
            //maxHeight:"620px",
            backgroundColor:"#FFFFFF",
            boxSizing:"border-box",
        },

        App: {
            width:"100%",
            height:"100%",
            maxWidth:"480px",
            maxHeight:"640px",
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
            boxShadow:"0px 0px 2px 1px #E5E5E5",
            backgroundColor: Theme.palette.primary.contrastText,
            overflow:"hidden",
            //backgroundColor: "#D8F2DA",
        },
        AppBar: {
            padding:"0em 0",
            color: Theme.palette.primary.contrastText,
            fontWeight:"bold",
        },
        changer: {
            top:"auto",
            bottom:"0",
        },
        Toolbar: {
            padding:"0!important",
            paddingLeft:"1em!important",
        },
        grow: {
            flexGrow: 1,
        },
        cemetery: {
            marginTop:"1.5em",
            padding:"0 0.5em",
        },
        fabAddHaiku: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"auto",
            right:"1em",
            //transform : "translate(-50%,0%)",
            //webkitTransform : "translate(-50%,0%)",
            //msTransform : "translate(-50%,0%)",
            color:Theme.palette.primary.contrastText,
        },
        fabClose: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"50%",
            right:"auto",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
            color:Theme.palette.primary.contrastText,
        },
        primary: {
            color: Theme.palette.primary.main,
        },
        primaryText: {
            color: Theme.palette.primary.contrastText,
        },
        secondary: {
            color: Theme.palette.secondary.main,
        },
        link: {
            color: Theme.palette.secondary.dark,
        },
        yes: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"auto",
            right:"1em",
            color:Theme.palette.primary.contrastText,
        },
        no: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"1em",
            right:"auto",
            color:Theme.palette.primary.contrastText,
        },
        withIcon: {
            display:"inline-flex",
            verticalAlign:"middle",
        },
        openBox: {
            position:"relative",
            border:`1px solid ${Theme.palette.secondary.dark}`,
            color:Theme.palette.secondary.dark,
            height:"5em",
            margin:"0 0.25em",
            marginBottom:"0.6em",
            boxSizing:"border-box",
            fontSize:"90%",
            cursor:"pointer",
            //overflow:"hidden",
        },
        lockedBox: {
            position:"relative",
            backgroundColor:Theme.palette.secondary.dark,
            color:Theme.palette.secondary.contrastText,
            height:"5em",
            margin:"0 0.25em",
            marginBottom:"0.6em",
            boxSizing:"border-box",
            fontSize:"90%",
            cursor:"pointer",
            //overflow:"hidden",
        },
        lockedIcon: {
            position:"absolute",
            top:"50%",
            left:"50%",
            fontSize:"180%",
            cursor:"pointer",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
        },
        boxValue: {
            position:"absolute",
            bottom:"-0.7em",
            //bottom:"0em",
            left:"50%",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
            backgroundColor:Theme.palette.primary.main,
            color:Theme.palette.primary.contrastText,
            width:"4em",
            padding:"0 0.25em",
            textAlign:"center",
            borderRadius:"0.25em",
            fontSize:"70%",
            whiteSpace:"nowrap",
        },
        boxHeart: {
            position:"absolute",
            bottom:"-1.2em",
            left:"50%",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
            color:"pink",
            textAlign:"center",
            fontSize:"70%",
            whiteSpace:"nowrap",
        },
        tate: {
            fontFamily: `'Yu Mincho', YuMincho, 'Hiragino Mincho ProN', 'Hiragino Mincho Pro', 'HGP明朝B', serif`,
            webkitFontFeatureSettings: 'pkna',
            fontFeatureSettings: 'pkna',
            webkitWritingMode: "vertical-rl",
            writingMode: "vertical-rl",
            position:"absolute",
            top:"0.5em",
            left:"50%",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
            fontSize:"90%",
            whiteSpace:"nowrap",
        },
        girlPhoto: {
            paddingRight:"1em",
            paddingBottom:"1em",
        },
        girlDataRow: {
            position: "relative",
        },
        girlDataRowName: {
            position: "absolute",
            top:"0.12em",
            left:"0",
            color: Theme.palette.primary.main,
            fontSize:"90%",
        },
        girlDataRowValue: {
            position: "relative",
            paddingLeft:"6em",
            textAlign:"right",
            color: "black",
            //borderBottom:"1px solid silver",
        },
        girlDataSleeping: {
            //marginBottom:"1em",
            borderTop: `1px solid ${Theme.palette.secondary.dark}`,
            borderBottom: `1px solid ${Theme.palette.secondary.dark}`,
            color: Theme.palette.secondary.dark,
            //color: Theme.palette.secondary.contrastText,
            padding:"0.5em 0",
            textAlign:"center",
        },
        girlTextSleeping: {
            color: "gray",
        },
        girlText: {
            color: Theme.palette.primary.main,
        },
        girlProfile: {
            //borderBottom:"1px solid silver",
            //borderRadius:"0.5em",
            padding:"0.5em 0",
            //paddingBottom:"1em",
            //marginTop:"2em",
            marginBottom:"0.5em",
            fontSize:"90%",
            minHeight:"4.7em",
            boxSizing:"border-box",
        },
        modalBottom: {
            position: "fixed",
            width:"100%",
            padding:"1em 1em",
            boxSizing: "border-box",
            bottom: "0",
            left:"0",
            backgroundColor:"white",
            borderTop:`1px solid #EEEEEE`,
            zIndex:9999,
        },
        bottomBar: {
            position: "fixed",
            width:"100%",
            padding:"1em 1em",
            boxSizing: "border-box",
            bottom: "0",
            left:"0",
            backgroundColor:"white",
            borderTop:`1px solid #EEEEEE`,
        },
        middleCenter: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
        },
        turn: {
            position:"fixed",
            textAlign: "right",
            width:"100%",
            bottom:"0.5em",
            fontSize:"100%",
            boxSizing:"border-box",
            paddingTop:"0.5em",
            paddingRight:"0.5em",
            borderTop:`1px solid ${Theme.palette.primary.light}`,
            color: Theme.palette.primary.main,
        },
        clickable: {
            cursor:"pointer",
        },
        subtitle1: {
            color: Theme.palette.secondary.dark,
        },
        formLabel: {
            color: Theme.palette.primary.main,
        },
        formValue: {
            marginBottom:"1em",
        },
   });
}